var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"opacity":"0.8","z-index":"300","value":_vm.loading || _vm.isLoading}},[_c('div',{staticClass:"pulse"},[_c('img',{attrs:{"src":"/static/image/footer/lb-official.png","width":"160","height":"56"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }